module.exports = __webpack_public_path__ + "img/7.642143f5.png";